import Header from "../components/Header";
import Banner from "../components/Banner";
import "../components/css/Home.css";

function Home() {
  

  return (
    <>
    
    <Header/>
    <Banner/>

    <div className="dashboard">
    
    </div>
    
    </>
  );
};

export default Home;
